/** Condição da obra no ícone (Figma icone-barco 713:28421): seco (dique seco) ou molhado (na água). */
export type IconeBarcoCondicao = "seco" | "molhado";

/** Nome acessível e texto da tooltip de cada condição (Figma, tooltips Seco e Molhado de 5632:87177). */
export const ICONE_BARCO_ROTULO: Record<IconeBarcoCondicao, string> = {
  seco: "Seco",
  molhado: "Molhado",
};
